import CreateCampaignPage from "./create-campaign.page";

export default CreateCampaignPage;
